import React, { useEffect, useState } from "react";
import DataTableBase from "../../../Components/Common/DataTableBase/DataTableBase";
import { t } from "i18next";
import { useLinksStore } from "../../../stores/Assets/links";
import { useStaffStore } from "../../../stores/Staffs";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  UncontrolledTooltip,
  Input,
  Label,
  FormGroup,
  Badge,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import AddLink from "../Links/Components/AddLink";
import InvitationsModal from "../../Staffs/components/InvitationsModal";
import DetailsModal from "./Components/DetailsModal";

import { Link, useLocation } from "react-router-dom";
import { useConfirmDialogStore } from "../../../stores/Modal/ConfirmDialogStore";
import { Pagination } from "../../../Components/Common/DataTableBase/Pagination";
import { useSiteStore } from "../../../stores/Assets/site";
import { canEdit } from "../../../helpers/permissions";
import { useSpaceStore } from "../../../stores/Assets/space";
import { Card, CardBody, CardHeader } from "reactstrap";
import ReactSelect from "react-select";
import { reactSelectStyling } from "../../../Components/Common/Forms/FormikInputHelper";
import Skeleton from "../../../Components/Common/Skeleton";
import moment from "moment";

const ManageTeam = () => {
  const [totalRows, setTotalRows] = useState(0);
  const [formattedLinks, setFormattedLinks] = useState([]);
  const [filteredLinks, setFilteredLinks] = useState([]);
  const { getSites, sites } = useSiteStore((state) => state);
  const { getSpaces, spaces, ...restSpace } = useSpaceStore((state) => state);
  document.title = "Clickorder Admin";
  const location = useLocation();
  const menuId = new URLSearchParams(location.search).get("menuId");
  const {
    removeLink,

  } = useLinksStore((state) => state);

  const {
    getTeamManagementData,
    teamManagementData,
    pagination,
    isLoading: teamLoading,
    isError: teamError,
    error: teamErrorMessage,
    cancelInvitation,
    resendInvitation,
  } = useStaffStore((state) => ({
    getTeamManagementData: state.getTeamManagementData,
    teamManagementData: state.teamManagementData,
    pagination: state.pagination,
    isLoading: state.isLoading,
    isError: state.isError,
    error: state.error,
    cancelInvitation: state.cancelInvitation,
    resendInvitation: state.resendInvitation,
  }));

  const [showSiteError, setShowSiteError] = useState(false);

  useEffect(() => {
    getSites();
    getTeamManagementData(null, { page: 1, perPage: rowsPerPage });
  }, [getSites, getTeamManagementData]);

  // Filter states
  const [selectedSite, setSelectedSite] = useState("");
  const [selectedSpace, setSelectedSpace] = useState("");
  const [selectedSpaceOption, setSelectedSpaceOption] = useState(null);
  const [emailSearch, setEmailSearch] = useState("");
  const [uniqueSpaces, setUniqueSpaces] = useState([]);

  useEffect(() => {
    if (selectedSite) {
      setSelectedSpaceOption(null); // Reset space selection when site changes
      setSelectedSpace("");
      getSpaces(selectedSite, { page: 1, perPage: 999 });

    }
  }, [selectedSite]);

  // Convert spaces to React Select options
  const spaceFilterOptions = [
    { value: "", label: "All" },
    ...spaces.map((space) => ({
      value: space.space_id,
      label: `${space.space_id} - ${space.name}`,
    })),
  ];
  useEffect(() => {
    if (teamManagementData) {

      setFormattedLinks(teamManagementData || []);
      setFilteredLinks(teamManagementData || []);

      setTotalRows(pagination?.totalItems || 0);
    }
  }, [teamManagementData]);

  // Columns for Space Links and Invitations table
  const columns = [
    {
      name: t("Type"),
      selector: (row) => row?.type,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <Badge color={row.type === 'link' ? 'success' : 'info'}>
          {row.type === 'link' ? 'LINK' : 'INVITATION'}
        </Badge>
      ),
    },
    {
      name: t("Site"),
      selector: (row) => row?.site_id,
      width: '200px',
      sortable: true,
      wrap: true,
      cell: (row) => <span classN ame="text-nowrap">{`(id:${row?.site_id}) ` + row?.site_name}</span>,
    },
    {
      name: t("Space"),
      selector: (row) => row?.space_id,
      width: '200px',
      sortable: true,
      wrap: true,
      cell: (row) => <span className="text-nowrap">{`(id:${row?.space_id}) ` + row?.space_name}</span>,
    },
    {
      name: t("User Email"),
      selector: (row) => row?.user_email,
      width: '200px',
      sortable: true,
      wrap: true,
    },
    {
      name: t("Status"),
      selector: (row) => row?.status,
      sortable: true,
      wrap: true,
      cell: (row) => {
        if (row.type === 'link') {
          return <Badge color="success">LINKED</Badge>;
        }

        const getStatusBadge = (status, expiresAt) => {
          const isExpired = new Date(expiresAt) < new Date();

          if (isExpired && status === "PENDING") {
            return <Badge color="warning">EXPIRED</Badge>;
          }

          switch (status) {
            case "PENDING":
              return <Badge color="info">PENDING</Badge>;
            case "ACCEPTED":
              return <Badge color="success">LINKED</Badge>;
            case "DECLINED":
              return <Badge color="danger">DECLINED</Badge>;
            case "CANCELLED":
              return <Badge color="secondary">CANCELLED</Badge>;
            case "EXPIRED":
              return <Badge color="warning">EXPIRED</Badge>;
            default:
              return <Badge color="light">UNKNOWN</Badge>;
          }
        };

        return getStatusBadge(row.status, row.expires_at);
      },
    },
  ];

  const { showConfirm } = useConfirmDialogStore((state) => state);

  const [showAddLink, setShowAddLink] = useState(false);
  const [showInvitationsModal, setShowInvitationsModal] = useState(false);
  const [showDetailsModal, setShowDetailsModal] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [actionLoading, setActionLoading] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState({});

  const toggleDropdown = (rowId) => {
    setDropdownOpen(prev => ({
      ...prev,
      [rowId]: !prev[rowId]
    }));
  };

  const showRowDetails = (rowData) => {
    setSelectedRowData(rowData);
    setShowDetailsModal(true);
  };

  const handleCancelInvitation = async (inviteId) => {
    try {
      setActionLoading(inviteId);
      await cancelInvitation(inviteId);
      // Refresh data after cancellation
      const filters = {};
      if (selectedSite) filters.site_id = parseInt(selectedSite);
      if (selectedSpace) filters.space_id = parseInt(selectedSpace);
      if (emailSearch && emailSearch.trim() !== "") filters.email = emailSearch.trim();
      getTeamManagementData(filters, { page: currentPage, perPage: rowsPerPage });
    } catch (error) {
      console.error("Error cancelling invitation:", error);
    } finally {
      setActionLoading(null);
    }
  };

  const handleResendInvitation = async (inviteId) => {
    try {
      setActionLoading(inviteId);
      await resendInvitation(inviteId);
    } catch (error) {
      console.error("Error resending invitation:", error);
    } finally {
      setActionLoading(null);
    }
  };

  const canResend = (status, expiresAt) => {
    const isExpired = new Date(expiresAt) < new Date();
    return status === "PENDING" && !isExpired;
  };

  const canCancel = (status) => {
    return status === "PENDING";
  };
  const toggleAddLinkModal = () => {
    if (sites.length === 0) {
      setShowSiteError(true);
      return;
    }
    setShowAddLink(!showAddLink);
  };

  const [currentLinks, setCurrentLinks] = useState([]);
  const [currentPage, setCurrentPage] = useState(1); // Track the current page
  const rowsPerPage = 10; // Display 10 rows per page

  const onChangePage = (page) => {
    const filters = {};

    if (selectedSite) {
      filters.site_id = parseInt(selectedSite);
    }

    if (selectedSpace) {
      filters.space_id = parseInt(selectedSpace);
    }

    if (emailSearch && emailSearch.trim() !== "") {
      filters.email = emailSearch.trim();
    }

    getTeamManagementData(filters, { page, perPage: rowsPerPage });
    setCurrentPage(page);
  };
  const deleteLink = async (body) => {
    try {
      await removeLink(body);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (teamManagementData?.pagination) {
      setTotalRows(teamManagementData.pagination.totalItems);
    }
  }, [teamManagementData]);
  const [canEditLink, setCanEditLink] = useState(false);

  useEffect(() => {
    const checkPermission = async () => {
      const res = await canEdit("link");
      setCanEditLink(res);
    };

    checkPermission();
  }, []);

  // Auto-apply filters when they change
  useEffect(() => {
    const filters = {};

    if (selectedSite) {
      filters.site_id = parseInt(selectedSite);
    }

    if (selectedSpace) {
      filters.space_id = parseInt(selectedSpace);
    }

    if (emailSearch && emailSearch.trim() !== "") {
      filters.email = emailSearch.trim();
    }

    getTeamManagementData(filters, { page: 1, perPage: rowsPerPage });
    setCurrentPage(1);
  }, [selectedSite, selectedSpace, emailSearch, getTeamManagementData]);

  return (
    <>
      {showSiteError && (
        <Modal isOpen={showSiteError} toggle={() => setShowSiteError(false)}>
          <ModalHeader>No Registered Site</ModalHeader>
          <ModalBody>
            <div className="text-center">
              <p className="text-danger">{t("You should first add a site.")}</p>
              <Link to="/sites" className="btn btn-primary">
                {t("Add a Site")}
              </Link>
            </div>
          </ModalBody>
        </Modal>
      )}
      <>
        <DataTableBase
          tableTitle={"MANAGE TEAM"}
          customHeader={
            sites.length === 0 ? (
              // Skeleton loading state
              <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
                <div className="w-100" style={{ flex: '0 0 10%' }}>
                  <Skeleton variant="button" />
                </div>
                <div className="d-flex flex-column flex-md-row align-items-stretch gap-2 w-100 px-2" style={{ flex: '0 0 60%' }}>
                  <div className="d-flex align-items-center gap-2 w-100">
                    <h6 className="text-nowrap mb-0">Site: </h6>
                    <div className="flex-grow-1">
                      <Skeleton variant="input" />
                    </div>
                  </div>

                  <div className="d-flex align-items-center gap-2 w-100">
                    <h6 className="text-nowrap mb-0">Email: </h6>
                    <div className="flex-grow-1">
                      <Skeleton variant="input" />
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="d-flex flex-column flex-md-row align-items-stretch justify-content-between gap-2 w-100 mb-2">
                <div className="d-flex gap-2" style={{ flex: '0 0 20%' }}>
                  {canEditLink ? (
                    <Button
                      color="success"
                      onClick={toggleAddLinkModal}
                      className="d-flex align-items-center justify-content-center"
                      style={{ padding: '0.4rem 1rem', whiteSpace: 'nowrap', fontSize: "13px" }}
                    >
                      + {t("Add Link")}
                    </Button>
                  ) : null}
                  {/* <Button
                    color="info"
                    onClick={() => setShowInvitationsModal(true)}
                    className="d-flex align-items-center justify-content-center"
                    style={{ padding: '0.4rem 1rem', whiteSpace: 'nowrap' }}
                  >
                    <i className="ri-mail-line me-1"></i>
                    Invitations
                  </Button> */}
                </div>
                <div className="d-flex flex-column flex-md-row align-items-stretch gap-2 w-100 px-2" style={{ flex: '0 0 60%' }}>
                  {sites.length > 0 && (
                    <div className="d-flex align-items-center gap-2 w-100">
                      <h6 className="text-nowrap mb-0">Site: </h6>
                      <select
                        className="form-control flex-grow-1"
                        value={selectedSite}
                        onChange={(e) => setSelectedSite(e.target.value)}
                      >
                        <option key={"all"} value={""}>
                          {"All"}
                        </option>
                        {sites.map((site, indx) => (
                          <option key={indx} value={site.site_id}>
                            {site.site_id} - {site.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}

                  {selectedSite && (
                    <div className="d-flex align-items-center gap-2 w-100">
                      <h6 className="text-nowrap mb-0">Space: </h6>
                      <div className="flex-grow-1">
                        <ReactSelect
                          {...reactSelectStyling}
                          options={spaceFilterOptions}
                          value={selectedSpaceOption}
                          onChange={(option) => {
                            setSelectedSpaceOption(option);
                            setSelectedSpace(option?.value || "");
                          }}
                          placeholder={t("Select Space...")}
                          isLoading={restSpace.isLoading}
                          isDisabled={restSpace.isLoading}
                          isClearable
                        />
                      </div>
                    </div>
                  )}

                  <div className="d-flex align-items-center gap-2 mr-3 w-100">
                    <h6 className="text-nowrap mb-0">Email: </h6>
                    <Input
                      className="flex-grow-1"
                      id="email-search"
                      type="text"
                      placeholder="Search by email..."
                      value={emailSearch}
                      onChange={(e) => setEmailSearch(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )
          }
          data={formattedLinks} // Display current paginated data
          columns={columns}
          loading={teamLoading}
          paginationTotalRows={totalRows}
          onChangePage={onChangePage}
          onHeaderAddBtnClick={null}
          showSearch={false}
          showActionColumn={canEditLink}
          showSubHeader={false}
          showActionButtons={false}
          customActionBtns={(row) => {
            const rowId = `${row.type}_${row.user_email}_${row.space_id}`;
            const isDropdownOpen = dropdownOpen[rowId] || false;

            // Determine available actions based on row type
            const actions = [];

            // Add View Details action for all rows
            actions.push({
              label: 'View Details',
              icon: 'ri-eye-line',
              color: 'info',
              action: () => {
                showRowDetails(row);
              }
            });

            if (row.type === 'link') {
              actions.push({
                label: 'Delete Link',
                icon: 'ri-delete-bin-line',
                color: 'danger',
                action: () => {
                  showConfirm(
                    () => {
                      deleteLink({
                        email: row?.user_email,
                        space_id: row?.space_id,
                      });
                    },
                    () => {
                      console.log("Cancelled");
                    },
                    "Confirmation",
                    `Are you sure you want to delete the link?`
                  );
                }
              });
            } else if (row.type === 'invitation') {
              // Allow deletion for accepted invitations (they are established links)
              if (row.status === 'ACCEPTED') {
                actions.push({
                  label: 'Delete Link',
                  icon: 'ri-delete-bin-line',
                  color: 'danger',
                  action: () => {
                    showConfirm(
                      () => {
                        deleteLink({
                          email: row?.user_email,
                          space_id: row?.space_id,
                        });
                      },
                      () => {
                        console.log("Cancelled");
                      },
                      "Confirmation",
                      `Are you sure you want to delete this established link?`
                    );
                  }
                });
              }

              if (canCancel(row.status)) {
                actions.push({
                  label: 'Cancel Invitation',
                  icon: 'ri-close-circle-line',
                  color: 'warning',
                  action: () => {
                    showConfirm(
                      () => {
                        handleCancelInvitation(row.invite_id);
                      },
                      () => {
                        console.log("Cancelled");
                      },
                      "Confirmation",
                      `Are you sure you want to cancel this invitation?`
                    );
                  }
                });
              }

              if (canResend(row.status, row.expires_at)) {
                actions.push({
                  label: 'Resend Invitation',
                  icon: 'ri-mail-send-line',
                  color: 'info',
                  action: () => {
                    handleResendInvitation(row.invite_id);
                  }
                });
              }
            }

            // Always show dropdown since we have at least View Details action
            return (
              <Dropdown isOpen={isDropdownOpen} toggle={() => toggleDropdown(rowId)}>
                <DropdownToggle className="btn btn-sm " style={{ backgroundColor: "#ce9558", color: "white", border: "none" }}>
                  <i className="ri-more-2-line"></i>
                </DropdownToggle>
                <DropdownMenu>
                  {actions.map((action, index) => (
                    <DropdownItem
                      key={index}
                      onClick={action.action}

                    >
                      <i className={`${action.icon} me-2`}></i>
                      {action.label}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            );
          }}
        />

        {showAddLink && !showSiteError && (
          <AddLink
            sites={sites}
            toggleAddLinkModal={toggleAddLinkModal}
            showAddLinkModal={showAddLink}
          />
        )}
        {showInvitationsModal && (
          <InvitationsModal
            isOpen={showInvitationsModal}
            toggle={() => setShowInvitationsModal(!showInvitationsModal)}
          />
        )}

        <DetailsModal
          isOpen={showDetailsModal}
          toggle={() => setShowDetailsModal(false)}
          rowData={selectedRowData}
        />
      </>
    </>
  );
};

export default ManageTeam;
